import React from 'react';

import styels from './index.less';

const RizhaoContent = ({ children }) => {
  return (
    <div className={styels.wrap}>
      {children}
    </div>
  );
};

export default RizhaoContent;
